import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { STATS } from "@/data/site";

function Counter({ value, suffix }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-50px" });
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const dur = 1800;
    const start = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / dur);
      const eased = 1 - Math.pow(1 - p, 3);
      setN(Math.floor(eased * value));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);
  const formatted = value >= 1000 ? n.toLocaleString("en-IN") : n;
  return <span ref={ref}>{formatted}{suffix}</span>;
}

export default function Stats() {
  return (
    <section className="relative py-28 md:py-40 bg-[#EDE6D2] border-y border-[#0A0A14]/12" data-testid="stats">
      <div className="container-mit">
        <div className="flex items-baseline justify-between mb-14">
          <p className="text-[11px] tracking-[0.4em] text-[#A4801C]">— IN NUMBERS</p>
          <p className="text-[11px] tracking-[0.3em] text-[#0A0A14]/50">PAN INDIA · SINCE 2012</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-14">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="pl-6 border-l border-[#1E1B4B]/40"
              data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div className="font-display text-6xl md:text-7xl font-light text-[#0A0A14] leading-none">
                <Counter value={s.value} suffix={s.suffix} />
              </div>
              <div className="mt-4 text-[11px] tracking-[0.3em] text-[#0A0A14]/65 uppercase">{s.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
